import { useEffect, useState } from "react";

const frequencies = [
    { label: "1 day", value: 1 },
    { label: "3 days", value: 3 },
    { label: "5 days", value: 5 },
    { label: "7 days", value: 7 },
    { label: "15 days", value: 15 },
    { label: "30 days", value: 30 },
  ];

const FrequencySelector = ({ frequency, onFrequencyChange }) => {
  const [selectedFrequency, setSelectedFrequency] = useState(null);

  const handleChange = (e) => {
    setSelectedFrequency(e.target.value);
    if (onFrequencyChange) onFrequencyChange(e.target.value);
  };

  useEffect(() => {
    setSelectedFrequency(frequency || 3)
  }, [frequency])

  return (
    <div>
      <label className="form-label fw-semibold mb-3">Select reminder frequency:</label>
      <div className="d-flex justify-content-start gap-4 flex-wrap">
        {frequencies.map((freq) => (
          <div
            key={freq.value}
            className="d-flex flex-column align-items-center"
            style={{ cursor: "pointer" }}
            onClick={() => {
              setSelectedFrequency(freq.value);
              if (onFrequencyChange) onFrequencyChange(freq.value);
            }}
          >
            <input
              type="radio"
              name="frequency"
              value={freq.value}
              checked={selectedFrequency === freq.value}
              onChange={handleChange}
              className="btn-check"
              id={`freq-${freq.value}`}
              autoComplete="off"
              style={{ display: "none" }}
            />
            <label
              htmlFor={`freq-${freq.value}`}
              className="rounded-circle border border-3 d-flex justify-content-center align-items-center"
              style={{
                width: "24px",
                height: "24px",
                transition: "background-color 0.3s, border-color 0.3s",
                backgroundColor: selectedFrequency === freq.value ? "#0d6efd" : "transparent",
                borderColor: selectedFrequency === freq.value ? "#0d6efd" : "#ced4da",
              }}
            >
              {selectedFrequency === freq.value && (
                <div
                  style={{
                    width: "12px",
                    height: "12px",
                    backgroundColor: "#fff",
                    borderRadius: "50%",
                  }}
                />
              )}
            </label>
            <small className="mt-1 text-muted" style={{ userSelect: "none", fontWeight: "500" }}>{freq.label}</small>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FrequencySelector;